exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.g-page-container{min-height:calc(\r var(--g--dvh, 1vh) * 100 - env(safe-area-inset-bottom) -\r env(keyboard-inset-height, 0))\n}\n", "", {"version":3,"sources":["D:/TsWeb/h5aliex/src/compontents/newHome/SiteBody.vue"],"names":[],"mappings":";AAAA,kBAAkB,0GAGa;CAC9B","file":"SiteBody.vue","sourcesContent":[".g-page-container{min-height:calc(\r var(--g--dvh, 1vh) * 100 - env(safe-area-inset-bottom) -\r env(keyboard-inset-height, 0px))}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d159d1a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/SiteBody.vue
// module id = Ahxl
// module chunks = 0